import { APP_ROLES } from 'store/enums';
import store from 'store';

export const userRole = () => store.getters['auth/data']('userInfo')?.role;

export const userProfile = () => store.getters['auth/data']('userInfo');

export const userPartnerId = () => store.getters['auth/data']('userInfo')?.partnerid;

export const userDriverId = () => store.getters['auth/data']('userInfo')?.id;

export const userName = () => {
  const profile = userProfile();
  return profile.name;
};

export const userContactId = () => {
  const profile = userProfile();
  return profile.contactId;
};

export const userSignedIn = () => store.getters['auth/data']('userInfo') !== null;

export const checkAvailabilityRole = (role, check) => {
  if (Array.isArray(role)) {
    return role.some(item => check.includes(item));
  }
  return check.includes(role);
};

export const userHasDriverRole = () => {
  const role = store.getters['auth/data']('userInfo')?.role;
  if (!role) return false;
  return checkAvailabilityRole(role, [APP_ROLES.DRIVER_ROLE]);
};
